module.exports = __webpack_public_path__ + "static/media/cross.87a14b4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cross.svg
// module id = 98
// module chunks = 0